window.Products.HomeDecor.BedPillowShamKing = function() {};
window.Products.HomeDecor.BedPillowShamKing.inherits(window.Products.HomeDecor.BedPillowSham);
window.Products.HomeDecor.BedPillowShamKing.has_3d = true;
window.Products.HomeDecor.BedPillowShamKing.id = '89-king';
window.Products.HomeDecor.BedPillowShamKing.saveId = 89;
window.Products.HomeDecor.BedPillowShamKing.slug = 'bed-pillow-sham-king';
window.Products.HomeDecor.BedPillowShamKing.dpi = 150;